import to from '@/lib/to'

const SNAPSHOT_REFRESH_TIMEOUT_MS = 120000

export default {
  data() {
    return {
      isRefreshing: false,
      snapshotRefreshTimer: null
    }
  },
  beforeUnmount() {
    this.clearSnapshotRefreshTimer()
  },
  methods: {
    async refreshSnapshot() {
      if (!this.refreshMonitorId || this.isRefreshing) {
        return
      }
      this.isRefreshing = true
      const [err] = await to(this.$http.post(`/patient_monitors/${this.refreshMonitorId}/refresh_snapshot`, {}, { skipLoading: true }))
      if (err) {
        this.failSnapshotRefresh()
        return
      }
      this.snapshotRefreshTimer = setTimeout(() => this.failSnapshotRefresh(), SNAPSHOT_REFRESH_TIMEOUT_MS)
    },
    completeSnapshotRefresh() {
      this.clearSnapshotRefreshTimer()
      this.isRefreshing = false
    },
    failSnapshotRefresh() {
      this.clearSnapshotRefreshTimer()
      this.isRefreshing = false
      this.$buefy.toast.open({
        message: 'AI service not available or reachable at this time.',
        type: 'is-danger',
        duration: 3000
      })
    },
    clearSnapshotRefreshTimer() {
      if (this.snapshotRefreshTimer) {
        clearTimeout(this.snapshotRefreshTimer)
        this.snapshotRefreshTimer = null
      }
    }
  }
}
